//
//
//
//
//
//
//
//
//
//
//

import { focus } from '~/helpers/directives';

export default {
  name: 'SfLink',
  directives: { focus },
  props: {
    link: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    isExternal() {
      return (
        typeof this.link === 'string' && this.link.search(/(^\/|^#)/g) === -1
      );
    },
    isNativeLinkTag() {
      return this.isExternal || !this.$router;
    },
    urlTag() {
      return this.isNativeLinkTag
        ? { href: this.link }
        : { to: this.link || '' };
    },
    linkComponentTag() {
      const routerLink = this.$nuxt ? 'nuxt-link' : 'router-link';
      return this.isNativeLinkTag ? 'a' : routerLink;
    },
  },
};
